export const TIRASPOT_POCT_RESULT_CORRECTION_KEY = 'final_POCT_result';
